import { createReducer, on } from '@ngrx/store';
import {
  AdminLoadOrganizations,
  AdminSetCurrentOrganization,
  AdminSetOrganizationError,
  AdminSetOrganizationsCsvError,
  AdminRemoveOrganizationError,
  AdminResetCurrentOrganization,
  AdminOrganizationPageChanged,
  AdminIncludedDeletedOrganizationsChanged,
  AdminOrganizationsLoaded,
  AdminOrganizationsExited,
  AdminOrganizationSortChanged,
  AdminOrganizationsSearchChanged,
  AdminOrganizationEffectActions,
  AdminOrganizationListActions,
} from './admin-organization.actions';
import {
  AdminOrganization,
  AdminOrganizationOrderByKey,
} from 'src/app/admin/models/organization.model';
import { AdminOrganizationApiError } from './admin-organization.errors';
import { SortOrder } from 'studio-components';

export interface AdminOrganizationState {
  search: string;
  includeDeleted: boolean;
  page: number;
  sortOrder: SortOrder;
  orderBy: AdminOrganizationOrderByKey;
  limit: number;
  organizations: AdminOrganization[];
  total: number;
  currentOrganization: AdminOrganization;
  apiError: AdminOrganizationApiError;
}

const initialState: AdminOrganizationState = {
  search: '',
  includeDeleted: false,
  page: 1,
  sortOrder: 'asc',
  orderBy: 'id',
  limit: 100,
  organizations: [],
  total: 0,
  currentOrganization: null,
  apiError: null,
};

export const adminOrganizationReducer = createReducer(
  initialState,
  on(AdminOrganizationPageChanged, (state, { page }) => ({
    ...state,
    page,
  })),
  on(AdminOrganizationsSearchChanged, (state, { search }) => ({
    ...state,
    search,
    page: 1,
  })),
  on(AdminOrganizationSortChanged, (state, { sortOrder, orderBy }) => ({
    ...state,
    sortOrder,
    orderBy,
    // always go back to the first page when sort is updated as ngx-datatable resets to page 1
    page: 1,
  })),
  on(AdminIncludedDeletedOrganizationsChanged, (state, { includeDeleted }) => ({
    ...state,
    includeDeleted,
  })),
  on(AdminLoadOrganizations, AdminResetCurrentOrganization, (state) => ({
    ...state,
    currentOrganization: null,
    apiError: null,
  })),
  on(AdminOrganizationsLoaded, (state, { organizations, total }) => ({
    ...state,
    organizations,
    total,
    apiError: null,
  })),
  on(AdminSetCurrentOrganization, (state, { organization }) => ({
    ...state,
    apiError: null,
    currentOrganization: organization,
  })),
  on(
    AdminSetOrganizationError,
    AdminSetOrganizationsCsvError,
    AdminOrganizationEffectActions.undeployAllProjectsInOrganizationErrored,
    (state, { error }) => ({
      ...state,
      apiError: error,
    }),
  ),
  on(
    AdminRemoveOrganizationError,
    AdminOrganizationListActions.undeployAllProjectsConfirmed,
    (state) => ({
      ...state,
      apiError: null,
    }),
  ),
  on(AdminOrganizationsExited, (state) => ({
    ...state,
    organizations: [],
  })),
);
